'use client';
import type { SeriesOverview } from '~/common/types/series-overview';
import { FollowRequiredModal } from './follow-required-modal';
import { useLocalHooks } from './use-local-hooks';

type Props = {
  series: SeriesOverview;
  referer?: string;
};

export const FollowRequiredModalContainer = ({ series, referer }: Props) => {
  const {
    isOpen,
    onClose,
    title,
    icon,
    note,
    buttonText,
    followButtonClick,
    isAuthorFollowed,
    userAvailability,
    reportLink,
  } = useLocalHooks(series, referer);
  return (
    <FollowRequiredModal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      icon={icon}
      note={note}
      buttonText={buttonText}
      followButtonClick={followButtonClick}
      isAuthorFollowed={isAuthorFollowed}
      userAvailability={userAvailability}
      reportLink={reportLink}
    />
  );
};
